import { useCallback, useEffect, useState } from "react";
import checkoutPageApi from "../../../services/checkoutPageApi";

/**
 * Fetches a published checkout page. No cache and no automatic retry — a stale
 * cached price is worse than a brief loading flash on a page that takes money.
 */
export default function useCheckoutPage(pageId, accessToken) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!pageId) {
      setError({ message: "Missing page id", status: 400 });
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await checkoutPageApi.getPublicPage(pageId, accessToken);
      setData(result);
    } catch (err) {
      setError(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [pageId, accessToken]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
